// Fixed set of steps for the top stepper bar - this is ALWAYS shown in
// full (Camera, Mic, Screen Share), regardless of which steps actually
// get skipped in `requiredSteps` because permission was already granted
// on mount. The stepper's active/completed state is derived from where
// `currentStepType` sits in this fixed list, not from `requiredSteps`.
export const ALL_STEPS = ['camera', 'mic', 'screen'];

export const stepConfig = {
  camera: {
    label: 'Step 1',
    // Camera is always the first step, so its index (0) can never be
    // greater than currentFullStepIndex - it's never rendered 'notdone',
    // so no inactive/unselected variant is needed.
    iconCurrent: '/svgs/camera-permission.svg',
    iconDone: '/svgs/camera-permission-done.svg'
  },
  mic: {
    label: 'Step 2',
    iconCurrent: '/svgs/mic-permission.svg',
    iconDone: '/svgs/mic-permission-done.svg',
    iconInactive: '/svgs/mic-permission-unselected.svg'
  },
  screen: {
    label: 'Step 3',
    iconCurrent: '/svgs/screen-share-permission.svg',
    iconDone: '/svgs/screen-share-permission-done.svg',
    iconInactive: '/svgs/screen-share-permission-unselected.svg'
  }
};
